import store from "../store";
import axios from "axios";

class Projects {

	generate_last_treatments()
	{
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/projects/generate_last_treatments", {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getAll(no_format = false, archive = false, client_uid = false, all = false, shared = false) {
		var query = "?";
		if (no_format) 
			query += "no_format=true";
		else 
			query += "no_format=";
		if (archive) 
			query += "&archive=true";
		else 
			query += "&archive=";
		if (client_uid) 
			query += "&client_uid=" + client_uid;
		else 
			query += "&client_uid=";
		if (all)
			query += "&all=true"
		else
			query += "&all="
		// console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/projects' + no_format)
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/projects" + query, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data.projects);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getAllClients() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/projects/all", {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data.projects);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	get(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/projects/" + id, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data.project);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getSteps(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/projects/" + id + "/steps", {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data.steps);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	recordTestDate(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/projects/" + id + "/test_date", {}, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Projects();
